export const readCookieValue = (name: string): string | null => {
  if (typeof document === 'undefined') return null

  try {
    const targetName = name.trim()
    if (!targetName) return null

    const rawPair = document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${targetName}=`))

    if (!rawPair) return null

    const rawValue = rawPair.slice(targetName.length + 1).trim()
    if (!rawValue) return null

    return decodeURIComponent(rawValue)
  } catch {
    return null
  }
}
